import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import { EDialogAction } from "../Components/Enum/DialogActionEnum";
import JobTitlesTable from "../Components/JobTitles/JobTitlesTable";
import JobTitlesDialogBox from "../Components/JobTitles/JobTitlesDialogBox";
import ProcessTable from "../Components/Process/ProcessTable";
import Scaffold from "../Components/Layout/Scaffold";
import { Button, Card } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import { ProcessEnum, ProcessEnumDisplayLabel } from "../Types/Enum";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { subMonths, startOfMonth, endOfMonth, format } from "date-fns";

const Processes = () => {
  let [hide, setHide] = useState(true);

  let [filter, setfilter] = useState<any>({});
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [textInput, setTextInput] = useState("");
  const [selectedRange, setSelectedRange] = useState("");

  const handleTextInputChange = (event: any) => {
    setTextInput(event.target.value);
  };

  const handleChange = (event: any) => {
    const { value } = event.target;
    setSelectedRange(value);

    if (value === "last_month") {
      // Get start and end dates for the previous month
      const startDate = startOfMonth(subMonths(new Date(), 1));
      const endDate = endOfMonth(subMonths(new Date(), 1));

      // Update filter state with the selected range
      setfilter({
        ...filter,
        start_date: format(startDate, "yyyy-MM-dd"),
        end_date: format(endDate, "yyyy-MM-dd"),
      });
    }
  };

  function hideDiv() {
    if (hide == true) {
      setHide(false);
    } else {
      setHide(true);
    }
  }

  function changeFilters(key: string, value: string | Date | null) {
    setfilter((oldState: any) => {
      return { ...oldState, [key]: value };
    });
  }

  function clearData() {
    setSelectedRange("");
    setfilter({});
  }
  function clearSearch() {
    setTextInput("");
    setfilter({});
  }

  function editDialogClose() {
    setEditDialogVisibility(false);
    changeFilters("timestamp", "" + Date.now());
  }

  return (
    <Scaffold
      title="Processes"
      actions={[
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": {
              maxWidth: "75ch",
            },
          }}
          noValidate
          autoComplete="off"
        >
          <div>
            <TextField
              id="outlined-search"
              type="search"
              label="Search"
              variant="outlined"
              size="small"
              placeholder="Enter search keyword"
              value={textInput}
              onChange={handleTextInputChange}
            />
          </div>
        </Box>,
        <Button
          endIcon={<SearchOutlined />}
          className="mx-1"
          variant="contained"
          color="secondary"
          onClick={() => {
            changeFilters("keyword", "" + textInput);
          }}
        >
          Search
        </Button>,
        <Button
          variant={hide ? "outlined" : "contained"}
          color="secondary"
          onClick={hideDiv}
          startIcon={<FilterAltIcon fontSize="small" />}
        >
          {hide ? "Show" : "Hide"} Filters
        </Button>,
      ]}
      secondaryAction={
        <>
          {!hide && (
            <Card
              className="flex w-full space-x-4 px-2 py-3 border"
              elevation={0}
            >
              <div className="flex">
                <TextField
                  id="passPort"
                  variant="outlined"
                  value={filter.passport || ""}
                  onChange={(event) => {
                    changeFilters("passport", event.target.value);
                    // if (event.target.value == "") {
                    //   // clearData();
                    // }
                  }}
                  placeholder="Passport"
                  size="small"
                  label="Passport"
                  name="title"
                />
              </div>
              <div className="flex">
                <div>
                  <FormControl size="small" sx={{ minWidth: 120 }}>
                    <InputLabel id="status-select-standard-label">
                      Status
                    </InputLabel>
                    <Select
                      size="small"
                      labelId="status-select-standard-label"
                      label="Status"
                      id="status-select-standard"
                      value={filter.status || ""}
                      onChange={(event) => {
                        changeFilters("status", event.target.value);
                        // if (event.target.value == "") {
                        //   clearData();
                        // }
                      }}
                    >
                      {Object.keys(ProcessEnumDisplayLabel).map((key) => (
                        <MenuItem key={key} value={key}>
                          {ProcessEnumDisplayLabel[key]}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="flex">
                <FormControl size="small" sx={{ minWidth: 120 }}>
                  <InputLabel id="range-select-standard-label">Range</InputLabel>
                  <Select
                    size="small"
                    labelId="range-select-standard-label"
                    label="Range"
                    value={selectedRange}
                    onChange={handleChange}
                  >
                    <MenuItem value="last_month">Last Month</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="flex align-items-end">
                <DatePicker
                  selected={(filter.start_date && new Date(filter.start_date)) || null}
                  onChange={(date) => changeFilters("start_date", date ? date.toISOString().split("T")[0] : null)}
                  placeholderText={"Select start date"}
                  dateFormat="yyyy-MM-dd"
                  isClearable
                  showYearDropdown
                  customInput={
                    <TextField
                      className="w-full"
                      variant="standard"
                      size="small"
                    />
                  }
                />
                <Box sx={{ mx: 2, alignSelf: "flex-center" }}> to </Box>
                <DatePicker
                  selected={(filter.end_date && new Date(filter.end_date)) || null}
                  onChange={(date) => changeFilters("end_date", date ? date.toISOString().split("T")[0] : null)}
                  placeholderText={"Select end date"}
                  dateFormat="yyyy-MM-dd"
                  isClearable
                  showYearDropdown
                  customInput={
                    <TextField
                      className="w-full"
                      variant="standard"
                      size="small"
                    />
                  }
                />
              </div>

              <Button
                variant="contained"
                color="secondary"
                size="small"
                endIcon={<SearchOutlined />}
                onClick={() => {
                  changeFilters("timestamp", "" + Date.now());
                }}
              >
                Search
              </Button>
              <Button
                className="mt-1"
                color="error"
                variant="text"
                onClick={clearData}
              >
                <CancelIcon />
              </Button>
            </Card>
          )}
        </>
      }
    >
      <div>
        <ProcessTable filter={filter} />
        <JobTitlesDialogBox
          open={editDialogVisibility}
          onClose={editDialogClose}
          data={{}}
          dialogAction={EDialogAction.create}
        />
      </div>

    </Scaffold>
  )

  return (
    <>
      <p className="text-2xl  ">Processes</p>
      {/* <div className="flex flex-col md:flex-row h-10"> */}
      {/* <div className="flex">
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": {
                width: "75ch",
              },
            }}
            noValidate
            autoComplete="off"
          >
            <div>
              <TextField
                id="outlined-search"
                type="search"
                inputProps={{
                  style: {
                    height: "3px",
                    fontSize: "14px",
                  },
                }}
                placeholder="Search"
                value={textInput}
                onChange={handleTextInputChange}
              />
            </div>
          </Box>
          {textInput != "" ? (
            <button onClick={clearSearch}>
              <CancelIcon />
            </button>
          ) : (
            <></>
          )}
          <div>
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded ml-4 text-sm mt-1"
              onClick={() => {
                changeFilters("keyword", "" + textInput);
              }}
            >
              Search
            </button>
          </div>
        </div> */}
      {/* <div className="flex  md:w-full md:justify-end space-x-2 mt-6 md:mt-0 -ml-4 md:-ml-0">
          <button
            className=" bg-green-600 hover:bg-green-500 text-white font-bold pr-4 pl-2 rounded-lg ml-4 text-sm h-8"
            onClick={() => {
              setEditDialogVisibility(true);
              console.log(editDialogVisibility);
            }}
          >
            <div className="flex">
              <AddIcon fontSize="small" />

              <p className="text-sm ">Create</p>
            </div>
          </button>
        </div> */}
      {/* </div> */}
      {/* <div className="flex   space-x-2 mt-6 md:mt-4 -ml-4 md:-ml-3">
        <button
          className="flex bg-green-600 hover:bg-green-500 text-white font-bold py-1 pr-4 pl-2 rounded-lg ml-4"
          onClick={hideDiv}
        >
          <FilterAltIcon fontSize="small" />

          <p className="text-sm ml-1">More Filters</p>
        </button>
      </div> */}
      {/* {!hide ? (
        <div> */}
      {/* <div className="flex w-full"> */}
      {/* <div className="flex ">
              <DateRangePicker />
            </div> */}

      {/* <div className="flex">
              <div>
                <FormControl size="small" sx={{ m: 1, minWidth: 120 }}>
                  <InputLabel id="demo-simple-select-standard-label">
                    Type
                  </InputLabel>
                  <Select
                    style={{
                      width: 150,
                      height: 30,
                      fontSize: 14,
                      marginTop: 5,
                    }}
                    size="small"
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={filter["status"]}
                    onChange={(event) => {
                      changeFilters("type", event.target.value);
                    }}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={"dom"}>Domestic</MenuItem>
                    <MenuItem value={"corp"}>Corporate</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div> */}
      {/* <div className="flex mt-2">
              <TextField
                id="title"
                variant="outlined"
                style={{ width: 160 }}
                onChange={(event) => {
                  changeFilters("title[eq]", event.target.value);
                }}
                placeholder="Title"
                size="small"
                name="title"
              />
            </div> */}
      {/* <div className="space-x-2 mt-6 md:mt-3 -ml-4 md:ml-3">
              <button
                className="flex bg-blue-800 hover:bg-blue-500 text-white font-bold py-1 pr-4 pl-2 rounded-lg ml-4 text-sm"
                onClick={() => {
                  changeFilters("timestamp", "" + Date.now());
                }}
              >
                <p className="text-sm ml-1">Search</p>
              </button>
            </div>
            <div
              className="space-x-2 mt-6 md:mt-3 -ml-4 md:ml-3"
              onClick={clearData}
            >
              <button>
                <CancelIcon className="mt-1" fontSize="small" />
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )} */}
      <div className="-mt-2">
        <ProcessTable filter={filter} />
      </div>
      <div>
        <JobTitlesDialogBox
          open={editDialogVisibility}
          onClose={editDialogClose}
          data={{}}
          dialogAction={EDialogAction.create}
        />
      </div>
    </>
  );
};

export default Processes;
